// eslint-disable-next-line no-shadow
export enum BackupCoordinatorStatus {
  // eslint-disable-next-line no-unused-vars
  StandBy = 'StandBy',
  // eslint-disable-next-line no-unused-vars
  Down = 'Down',
  // eslint-disable-next-line no-unused-vars
  Incompatible = 'Incompatible',
  // eslint-disable-next-line no-unused-vars
  NotConfigured = 'NotConfigured',
}
